import {
  type CardContentProps,
  Card as MuiCard,
  CardContent as MuiCardContent,
} from '@mui/material';
import { LinearProgress, useTheme } from 'hephaestus/web';
import { forwardRef } from 'react';
import { useCardTokens } from './card.tokens';

type CardProps = {
  children: React.ReactNode | React.ReactNode[];
  variant?: 'elevated' | 'outlined' | 'none';
  sx?: any;
  onClick?: (e?: any) => void;
  hover?: boolean;
  fullWidthOnMobile?: boolean;
  loading?: boolean;
  ref?: any;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      children,
      variant = 'elevated',
      sx,
      onClick,
      hover = false,
      fullWidthOnMobile = false,
      loading,
    },
    ref,
  ) => {
    const theme = useTheme();
    const tokens = useCardTokens(theme);

    return (
      <MuiCard
        ref={ref}
        onClick={onClick}
        elevation={0}
        sx={{
          borderRadius: {
            xs: fullWidthOnMobile ? '0px' : tokens.borderRadius,
            sm: tokens.borderRadius,
          },
          background: tokens.background.color,
          color: tokens.text.color,
          boxShadow: variant === 'elevated' ? tokens.elevation : 'none',
          border: variant === 'outlined' ? tokens.border : 'none',
          '&:hover': {
            boxShadow: hover && tokens.hoverElevation,
            cursor: hover && 'pointer',
          },
          marginLeft: { xs: fullWidthOnMobile ? '-16px' : 0, sm: 0 },
          marginRight: { xs: fullWidthOnMobile ? '-16px' : 0, sm: 0 },
          position: 'relative',
          ...sx,
        }}
      >
        {loading && <LinearProgress size='small' sx={{ mb: -0.5 }} />}
        {children}
      </MuiCard>
    );
  },
);
export const CardContent = (props: CardContentProps) => (
  <MuiCardContent
    sx={{ padding: '16px', paddingBottom: '16px', ...props.sx }}
    {...props}
  />
);
